import React from 'react';
import styled from 'styled-components';

import Error from '../elements/renderError';

const Wrapper = styled.div`
  text-align: center;
`;

const Area = styled.textarea`
  box-sizing: border-box;
  height: ${({ height = 211 }) => height}px;
  width: 360px;
  padding: 15px 20px;
  border: solid 1px ${props => props.theme.primary};
  color: ${props => props.theme.secondary};
  font-size: 14px;
  resize: none;
  font-family: inherit;
`;

const TextArea = ({ label, input, type, meta, height }) => (
  <Wrapper>
    <Area {...input} height={height} />
    <Error meta={meta} errorHeight={30} />
  </Wrapper>
);

export default TextArea;
